import { Dialog, DialogContent, Typography, Box, LinearProgress } from '@mui/material';

interface ModalProgressProps {
  open: boolean;
  message?: string;
}

const ModalProgress: React.FC<ModalProgressProps> = ({
  open,
  message = 'Procesando...',
}) => {
  return (
    <Dialog
      open={open}
      maxWidth="xs"
      fullWidth
      disableEscapeKeyDown // bloqueo
      //bloqueo
      onClose={(_event, reason)=>{
        if(reason==='backdropClick') return;
      }}
      PaperProps={{
        sx: {
          borderRadius: 3,
          p: 1,
        },
      }}
    >
      <DialogContent>
        <Box
          display="flex"
          flexDirection="column"
          gap={2}
          py={1}
          width="100%"
        >
          <Typography 
            variant="subtitle1" 
            fontWeight={600} 
            color="text.primary"
          >
            {message}
          </Typography>
          
          {/* Barra lineal animada estilizada */}
          <LinearProgress 
            sx={{ 
              height: 6, 
              borderRadius: 3,
              backgroundColor: (theme) => theme.palette.grey[100],
              '& .MuiLinearProgress-bar': {
                borderRadius: 3,
              }
            }} 
          />
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default ModalProgress;